<template>
    <section>
        <div class="text-heading-md font-extrabold">Display & Headings</div>
        <div class="text-md mt-3 font-semibold">Display lg</div>
        <div class="flex flex-row justify-evenly gap-4 text-display-lg">
            <div
                class="font-extrabold"
                contenteditable="true"
            >
                Extra bold
            </div>
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
        <div class="text-md mt-3 font-semibold">Display md</div>
        <div class="flex flex-row justify-evenly gap-4 text-display-md">
            <div
                class="font-extrabold"
                contenteditable="true"
            >
                Extra bold
            </div>
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
        <div class="text-md mt-3 font-semibold">Display sm</div>
        <div class="flex flex-row justify-evenly gap-4 text-display-sm">
            <div
                class="font-extrabold"
                contenteditable="true"
            >
                Extra bold
            </div>
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
        <div class="text-md mt-3 font-semibold">Heading lg</div>
        <div class="flex flex-row justify-evenly gap-4 text-heading-lg">
            <div
                class="font-bold"
                contenteditable="true"
            >
                Bold
            </div>
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
        <div class="text-md mt-3 font-semibold">Heading md</div>
        <div class="flex flex-row justify-evenly gap-4 text-heading-md">
            <div
                class="font-bold"
                contenteditable="true"
            >
                Bold
            </div>
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
        <div class="text-md mt-3 font-semibold">Heading sm</div>
        <div class="flex flex-row justify-evenly gap-4 text-heading-sm">
            <div
                class="font-bold"
                contenteditable="true"
            >
                Bold
            </div>
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
        <div class="text-heading-md font-extrabold">Body</div>
        <div class="text-md mt-3 font-semibold">Content lg</div>
        <div class="flex flex-row justify-evenly gap-4 text-content-lg">
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-medium"
                contenteditable="true"
            >
                Medium
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
        <div class="text-md mt-3 font-semibold">Content md</div>
        <div class="flex flex-row justify-evenly gap-4 text-content-md">
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-medium"
                contenteditable="true"
            >
                Medium
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
        <div class="text-md mt-3 font-semibold">Content sm</div>
        <div class="flex flex-row justify-evenly gap-4 text-content-sm">
            <div
                class="font-semibold"
                contenteditable="true"
            >
                Semi bold
            </div>
            <div
                class="font-medium"
                contenteditable="true"
            >
                Normal
            </div>
            <div
                class="font-normal"
                contenteditable="true"
            >
                Normal
            </div>
        </div>
    </section>
</template>

<script setup lang="ts"></script>
